import { useState } from 'react';
import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(null);

  const toggle = (id: string) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-900">常见问题</h2>
        </div>

        <div className="space-y-3 md:space-y-4">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full flex items-center justify-between p-4 md:p-5 text-left cursor-pointer hover:bg-background-100/50 transition-colors duration-200"
              >
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <span className={`flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-200 ${
                  openId === faq.id
                    ? 'bg-primary-500 text-background-50 rotate-45'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className="ri-add-line text-lg"></i>
                </span>
              </button>

              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openId === faq.id ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <p className="text-sm text-foreground-600 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}